export const REQUIRED_PAGES = ["data", "description", "rules"]
export const ERROR_METRICS  = { // NOTE: This should not be hardcoded, but read from the API instead.
  null:                           "No scoring",
  abs_mbe:                        "ABS Mean Bias Error (ABS MBE)",
  abs_mbe_grouped:                "ABS Mean Bias Error Grouped (ABS MBEg)",
  afrollm_batched:                "AfroLLM Batched",
  afrolm_bertscore_f1:            "AfroLLM BERT F1",
  always_zero:                    "Always Zero",
  area_under_curve:               "Area Under Curve (AUC)",
  bleu:                           "Rouge F-measure",
  character_error_rate:           "Character Error Rate (CER)",
  character_error_rate_weighted:  "Character Error Rate Weighted (CERw)",
  dsn_ai_bootcamp_qualification:  "DSC Academy - Hard hat",
  f1:                             "F1 Micro",
  f1_at_50:                       "F1 at 50",
  f1_multiclass:                  "F1 Multiclass",
  fairness:                       "Fairness",
  green_telecom_final:            "Green Telecom Final",
  green_telecom_public:           "Green Telecom Public",
  hamming_loss:                   "Hamming Loss",
  ibm_offboard:                   "RL BMI Malaria",
  indaba_grand:                   "RL Indaba Grand Challenge",
  instadeep_auc:                  "Instadeep AUC",
  intersection_over_union:        "Intersection Over Union",
  iou_polygon:                    "Intersection Over Union Polygon",
  iou_polygon_geo:                "Intersection Over Union Polygon Geo",
  lelapa:                         "Lelapa",
  llm_judge_ciat:                 "LLM Judge CIAT",
  llm_judge_force_n:              "LLM Judge Force N",
  llm_judge_itu_carbon:           "LLM Judge ITU Carbon",
  llm_judge_proposal_evaluation:  "LLM Judge Proposal Evaluation",
  log_loss:                       "Log Loss",
  mae:                            "Mean Absolute Error (Lacuna)",
  map_at_intersection_over_union: "MAP at Intersection Over Union",
  mean_absolute_error:            "Mean Absolute Error",
  mean_absolute_precision3:       "Mean Absolute Precision @ 3",
  mean_absolute_precision5:       "Mean Absolute Precision @ 5",
  multi:                          "Multi Error Metric (please use Avo to configure)",
  multi_col_acc:                  "Multi Column Accuracy",
  pass_at_1:                      "Pass at 1",
  recall_score:                   "Recall",
  reinforcement_learning:         "Reinforcement learning",
  rmse_grouped:                   "Root Mean Squared Error Grouped (RMSEg)",
  root_mean_squared_error:        "Root Mean Squared Error (RMSE)",
  rouge_1_f1:                     "Rouge 1 F1",
  rouge_l_f1:                     "Rouge L F1",
  ruby_bleu:                      "BLEU (Ruby, deprecated)",
  sea_turtles:                    "Intersection Over Union Turtles Bounding Box",
  straight_accuracy:              "Straight Accuracy",
  telco_track_a_iou:              "Telco Track A IOU",
  telco_track_b_acc:              "Telco Track B Accuracy",
  uber_ambulance:                 "Uber Nairobi Ambulance Perambulation",
  union_scoring_with_accuracy:    "Union Scoring with Accuracy",
  wmape:                          "Weighted Mean Absolute Percentage Error",
  word_error_rate:                "Word Error Rate (WER)",
  word_error_rate_weighted:       "Word Error Rate Weighted (WERw)",
}
